import { Component, computed, input } from '@angular/core';
import { NavIconName } from './nav-icon-sprite';

/**
 * Иконка shell. Геометрия лежит в спрайте `NavIconSprite`, здесь — только
 * ссылка на нужный символ: `<use>` наследует размер и цвет от рисующей `<svg>`,
 * поэтому инлайн-разметка иконок в шаблоне не нужна.
 */
@Component({
    selector: 'app-nav-icon',
    template: `<svg aria-hidden="true"><use [attr.href]="href()"></use></svg>`,
    styles: `
        :host {
            display: inline-flex;
        }

        svg {
            display: block;
            width: var(--nav-icon-size, 20px);
            height: var(--nav-icon-size, 20px);
            fill: none;
            stroke: currentColor;
            stroke-width: 1.8;
            stroke-linecap: round;
            stroke-linejoin: round;
        }
    `,
})
export class NavIcon {
    readonly name = input.required<NavIconName>();

    protected readonly href = computed(() => `#nav-icon-${this.name()}`);
}
